import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { db, auth } from '../firebaseConfig';
import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore';
import MenuBar from '../components/MenuBar';
import { FaRegBell, FaUserCheck, FaCog, FaComments, FaEnvelope } from 'react-icons/fa';
import '../styles/Settings.css';
import { PiNotePencilBold } from "react-icons/pi";
import { IoIosNotifications } from "react-icons/io";
import { FaAddressCard } from "react-icons/fa";

const Settings = () => {
  const [user, loading, error] = useAuthState(auth);
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [userName, setUserName] = useState("ゲスト"); // 初期値を「ゲスト」に設定

  useEffect(() => {
    const fetchUserData = async () => {
      if (user) {
        const docRef = doc(db, 'members', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setProfileImage(data.photoURL || null);
          setUserName(data.name || user.displayName || "ゲスト"); // nameが無ければdisplayName、それも無ければ「ゲスト」
        }
      }
    };

    const fetchUnreadNotifications = async () => {
      if (user) {
        const q = query(
          collection(db, `members/${user.uid}/notifications`),
          where('read', '==', false)
        );
        const querySnapshot = await getDocs(q);
        setHasUnreadNotifications(!querySnapshot.empty);
      }
    };

    if (user) {
      fetchUserData();
      fetchUnreadNotifications();
    }
  }, [user]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div className="settings-container">
      <div className="settings-header">
        <p className="settings-title">マイページ</p>
      </div>
      {/* 通知アイコン */}
      <Link to="/settingnotification" className="bell-icon-link">
        <FaRegBell className="bell-icon" />
        {hasUnreadNotifications && <div className="unread-indicator"></div>}
      </Link>

      {/* プロフィールセクション */}
      <div className="profile-edit-section">
        <div className="profile-section">
          {profileImage ? (
            <img src={profileImage} alt="Profile" className="profile-image" />
          ) : (
            <div className="placeholder-image">No Image</div>
          )}
          <div>
            <p className="username">{userName}</p> {/* `name` フィールドから取得した名前を表示 */}
            <Link to="/profile_edit" className="edit-profile-link">
              <PiNotePencilBold className="edit-icon" /> プロフィール編集
            </Link>
          </div>
        </div>
      </div>

      {/* 2列レイアウトメニュー */}
      <div className="settings-grid">
        <Link to="/age_verification" className="settings-item">
          <FaUserCheck className="settings-icon" />
          <span className="settings-item-text">年齢確認</span>
        </Link>
        <Link to="/paidservices" className="settings-item">
          <FaAddressCard className="settings-icon" />
          <span className="settings-item-text">会員ステータス</span>
        </Link>
        <Link to="/accountsettings" className="settings-item">
          <FaCog className="settings-icon" />
          <span className="settings-item-text">アカウント設定</span>
        </Link>
        <Link to="/chat-not-display" className="settings-item">
          <FaComments className="settings-icon" />
          <span className="settings-item-text">チャット非表示一覧</span>
        </Link>
        <Link to="/settingpush" className="settings-item">
          <IoIosNotifications className="settings-icon" />
          <span className="settings-item-text">通知設定</span>
        </Link>
        <Link to="/settinginquiry" className="settings-item">
          <FaEnvelope className="settings-icon" />
          <span className="settings-item-text">お問い合わせ</span>
        </Link>
      </div>

      <MenuBar />
    </div>
  );
};

export default Settings;
